/**
 * event 领域的 GameState 分片注册（事件通道）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { GameEventStateSchema, type GameEventState } from './types/event';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    events?: GameEventState;
  }
}

registerGameStateSlice('events', GameEventStateSchema.optional(), () => ({
  events: [],
  maxEvents: 300,
}));
